import { ElementTreeWalker, adjustedTabIndex, isTabbable } from '../../focus';
export function getTabbables(root, filter) {
    var walker = new ElementTreeWalker(root, function (node) {
        var tabbable = isTabbable(node);
        if (filter && tabbable) {
            return filter(node);
        }
        return tabbable;
    });
    var nodes = [];
    var regular = [];
    var index = 0;
    var node = null;
    while ((node = walker.next())) {
        var tabIndex = adjustedTabIndex(node);
        if (tabIndex === 0) {
            regular.push(node);
        }
        else {
            nodes.push({
                index: index++,
                tabIndex: tabIndex,
                node: node,
            });
        }
    }
    return nodes
        .sort(function (a, b) { return (a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex); })
        .map(function (v) { return v.node; })
        .concat(regular);
}
